/**
 * Zod schema for relevance scoring output.
 * Used with structured outputs to get guaranteed-valid JSON from the LLM.
 * Mirrors RelevanceResult in llm-adapter.ts.
 */

import { z } from 'zod';

export const RelevanceResultSchema = z.object({
  score: z.number().min(0).max(1),
  matchedIndicatorIds: z.array(z.string()),
});

export type RelevanceResult = z.infer<typeof RelevanceResultSchema>;
